import React from "react";
export default function Select(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  const isPlaceholderSelected = String(props.value ?? "") === "";

  return (
    <select
      {...props}
      className={[
        "h-[38px] w-full rounded-[8px] border",
        "border-[#D6DADF] bg-white px-3 text-sm outline-none",
        "[&>option]:text-[#111]",
        "focus:border-[#B5BBC2]",
        isPlaceholderSelected ? "text-[#B6BDC7]" : "text-[#111]",
        props.className || ""
      ].join(" ")}
    />
  );
}
